import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editedBy: {
		id: 'issue-comment-base.comment.edited-by',
		defaultMessage: '{timestamp} by {author}',
		description: 'Text for showing when an activity item was edited by a user',
	},
	anonymous: {
		id: 'issue-comment-base.comment.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Text to show for an anonymous user',
	},
	edit: {
		id: 'issue-comment-base.comment.edit',
		defaultMessage: 'Edit',
		description: '',
	},
	disabledEditTooltip: {
		id: 'issue-comment-base.comment.disabled-edit-tooltip.non-final',
		defaultMessage: 'View thread in Slack',
		description: 'Tooltip message when edit is disabled',
	},
	disabledDeleteTooltip: {
		id: 'issue-comment-base.comment.disabled-delete-tooltip.non-final',
		defaultMessage: 'View thread in Slack',
		description: 'Tooltip message when delete is disabled',
	},
	create: {
		id: 'issue-comment-base.comment.create',
		defaultMessage: 'Create',
		description: '',
	},
	createdIssue: {
		id: 'issue-comment-base.comment.created-issue',
		defaultMessage: 'I have created a work item from your comment',
		description: 'template message for issue created via comment',
	},
	createdIssueBySelf: {
		id: 'issue-comment-base.comment.created-issue-by-self',
		defaultMessage: 'I have created a work item from my comment',
		description: 'template message for issue created via comment by the same user',
	},
	new: {
		id: 'issue-comment-base.comment.new',
		defaultMessage: 'New',
		description: 'New indicator for comment',
	},
	hide: {
		id: 'issue-comment-base.comment.hide',
		defaultMessage: 'Hide',
		description: 'Text to show hide comment',
	},
	unhide: {
		id: 'issue-comment-base.comment.unhide',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Unhide',
		description: 'Text to show unhide comment',
	},
	delete: {
		id: 'issue-comment-base.comment.delete',
		defaultMessage: 'Delete',
		description: '',
	},
	commentDeleted: {
		id: 'issue-comment-base.comment.comment-deleted',
		defaultMessage: 'Comment deleted',
		description:
			'This text is shown in place of an actual comment when that comment has been deleted',
	},
	edited: {
		id: 'issue-comment-base.comment.edited',
		defaultMessage: 'Edited',
		description: '',
	},
	retrySave: {
		id: 'issue-comment-base.comment.retry-save',
		defaultMessage: 'Retry',
		description: '',
	},
	cancelSave: {
		id: 'issue-comment-base.comment.cancel-save',
		defaultMessage: 'Cancel',
		description: '',
	},
	saving: {
		id: 'issue-comment-base.comment.saving',
		defaultMessage: 'Saving...',
		description: '',
	},
	internalNote: {
		id: 'issue-comment-base.comment.internal-note',
		defaultMessage: 'Internal note',
		description: 'This text will be displayed next to lock icon if that comment is internal',
	},
	copy: {
		id: 'issue-comment-base.comment.copy',
		defaultMessage: 'Copy link to comment',
		description: 'Tooltip shown on hover',
	},
	createWorkItem: {
		id: 'issue-comment-base.comment.create-work-item',
		defaultMessage: 'Create work item',
		description: 'Tooltip shown on hover',
	},
	lozenge: {
		id: 'issue-comment-base.comment.lozenge',
		defaultMessage: 'Comments',
		description: 'This text will be displayed inside the comment lozenge',
	},
	addedCommentDescription: {
		id: 'issue-comment-base.comment.added-comment-description',
		defaultMessage: 'added a <span>Comment</span>',
		description: 'Should read as part of a sentence: {author name} added a Comment {date and time}',
	},
	addedCommentDescriptionLowercase: {
		id: 'issue-comment-base.comment.added-comment-description-lowercase',
		defaultMessage: 'added a <span>comment</span>',
		description: 'Should read as part of a sentence: {author name} added a comment {date and time}',
	},
	notRequestParticipant: {
		id: 'issue-comment-base.comment.not-request-participant',
		defaultMessage: '(not a request participant)',
		description:
			'This text will get concatenated with author name if user is not a request participant',
	},
	comment: {
		id: 'issue-comment-base.comment.comment',
		defaultMessage: 'Comment',
		description: 'Editor assisitive label for comment section',
	},
	reply: {
		id: 'issue-comment-base.comment.reply',
		defaultMessage: 'Reply',
		description: 'The text for CTA on a comment to reply, on the Jira issue view',
	},
	copyLink: {
		id: 'issue-comment-base.comment.copy-link',
		defaultMessage: 'Copy link',
		description: 'This text will be display for copy link comment action.',
	},
	moreActions: {
		id: 'issue-comment-base.comment.more-actions',
		defaultMessage: 'More actions',
		description: 'This text will be used for accessibility of meatball menu',
	},
	linkCopied: {
		id: 'issue-comment-base.comment.link-copied',
		defaultMessage: 'Link copied',
		description: 'This text will be display for copy link comment action.',
	},
	viaSlack: {
		id: 'issue-comment-base.comment.via-slack',
		defaultMessage: 'via Slack',
		description: 'This text will be display for comments thats synced via slack.',
	},
	viaSlackTooltip: {
		id: 'issue-comment-base.comment.via-slack-tooltip',
		defaultMessage: 'View thread in Slack',
		description: 'This text will be display for comments thats synced via slack on hover.',
	},
	slackFlagTitle: {
		id: 'issue-comment-base.comment.slack-flag-title.non-final',
		defaultMessage: 'You’re posting in a synced thread',
		description: 'This text will be display as the title for the slack flag',
	},
	slackFlagBody: {
		id: 'issue-comment-base.comment.slack-flag-body.non-final',
		defaultMessage: 'By posting this comment here in Jira, you will also be posting it in slack.',
		description: 'This text will be display as the body message for the slack flag',
	},
	slackFlagBtn: {
		id: 'issue-comment-base.comment.slack-flag-btn.non-final',
		defaultMessage: 'Understood',
		description: 'This text will be display as the body message for the slack flag',
	},
	pinComment: {
		id: 'issue-comment-base.comment.pin-comment',
		defaultMessage: 'Pin comment',
		description: 'Tooltip for the pin button',
	},
	unpinComment: {
		id: 'issue-comment-base.comment.unpin-comment',
		defaultMessage: 'Unpin comment',
		description: 'Tooltip for the unpin button',
	},
	scrollToComment: {
		id: 'issue-comment-base.comment.navigate-to-comment',
		defaultMessage: 'Navigate to comment',
		description: 'Menu item to navigate to comment from pinned comment section',
	},
});
